import React from 'react';
export function Marquee() {
  const text = '★ DROP חדש ★ משלוח חינם ★ מהדורה מוגבלת ';
  // Repeat enough times to fill the screen and loop smoothly
  const repeatedText = Array(10).fill(text).join('');
  return <div className="bg-black text-acid brutal-border border-l-0 border-r-0 border-t-0 overflow-hidden py-3 flex whitespace-nowrap relative" dir="ltr" data-id="element-109">
      <div className="animate-marquee-rtl font-archivo text-2xl font-black tracking-widest uppercase inline-block" data-id="element-110">
        {repeatedText}
      </div>
      <div className="animate-marquee-rtl font-archivo text-2xl font-black tracking-widest uppercase inline-block absolute top-3 right-full" data-id="element-111">
        {repeatedText}
      </div>
    </div>;
}